import axios from 'axios';
import config from 'config';
import { getAiAuthorizationClaims } from './aiChatAuthHelpers';

const {
  cognitiveLayer: {
    api: { dev: devUrl },
    endpoints: {
      aiWorkspace: { artifact },
    },
  },
} = config;

export const fetchAiWorkspaceArtifact = async (workspaceId, name, version) => {
  if (!workspaceId || !name || !Number.isInteger(version) || version < 1) {
    throw new Error('Workspace ID, artifact name, and version are required');
  }

  const artifactUrl = artifact
    .replace('{workspaceId}', encodeURIComponent(workspaceId))
    .replace('{name}', encodeURIComponent(name));
  const response = await axios.get(
    `${devUrl}${artifactUrl}?version=${version}&apiKey=${process.env.REACT_APP_TP_API_KEY_DEV}`,
    {
      headers: {
        'Authorization-Claims': getAiAuthorizationClaims(),
      },
    },
  );
  return response.data?.data;
};

export const fetchAiWorkspaceActiveArtifact = async (workspaceId, name) => {
  if (!workspaceId || !name) {
    throw new Error('Workspace ID and artifact name are required');
  }

  const artifactUrl = artifact
    .replace('{workspaceId}', encodeURIComponent(workspaceId))
    .replace('{name}', encodeURIComponent(name));
  const response = await axios.get(
    `${devUrl}${artifactUrl}?apiKey=${process.env.REACT_APP_TP_API_KEY_DEV}`,
    {
      headers: {
        'Authorization-Claims': getAiAuthorizationClaims(),
      },
    },
  );
  return response.data?.data;
};
